import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import { getAllItems } from "../itemsApi"

export const getAllSEPO = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "Supplies_expenses/get_all_supplies_expense",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getSingleSEPurchaseOrder = async (po_id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/get_supplies_expense",
      {
        requester: getUser(),
        token: getToken(),
        supplies_expense_id: po_id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getSingleSEPurchaseInvoice = async (pi_id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/get_receive",
      {
        requester: getUser(),
        token: getToken(),
        supplies_receive_id: pi_id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteSeAttachment = async (values) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/delete_attachment",
      {
        requester: getUser(),
        token: getToken(),
        ...values,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createSEPurchaseInvoice = async (
  invoice,
  items,
  additionalItems,
  supplies_expense_id
) => {
  try {
    var allItems = items.concat(additionalItems)

    const formData = new FormData()
    invoice.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_expense_id", supplies_expense_id)
    formData.append("supplier_id", invoice.supplier_id)
    formData.append("vendor_id", invoice.vendor_id)
    formData.append("branch_id", invoice.branch_id)
    formData.append("purchase_date", invoice.purchase_date)
    formData.append("supplies_receive_date", invoice.received_date)
    formData.append("due_date", invoice.due_date)
    formData.append("forwarder_id", invoice.forwarder_id)
    formData.append("waybill_no", invoice.waybill_no ? invoice.waybill_no : "")
    formData.append("invoice_no", invoice.invoice_no ? invoice.invoice_no : "")
    formData.append("dr_no", invoice.dr_no)
    formData.append("type", invoice.type)
    // formData.append('expense_type_id', invoice.type);
    formData.append("service_fee", invoice.service_fee)
    formData.append("discount", invoice.discount)
    formData.append("remarks", invoice.remarks ? invoice.remarks : "")
    formData.append("subtotal", invoice.subtotal)
    formData.append("grand_total", invoice.grand_total)

    formData.append("withholding_percentage", invoice.withholding_percentage)
    formData.append("vat_type", invoice.vat_type)
    formData.append("discounted_subtotal", invoice.discounted_subtotal)
    formData.append("vat", invoice.vat)
    formData.append("vatable_sales", invoice.vatable_sales)
    formData.append("withholding_tax", invoice.withholding_tax)
    formData.append(
      "grandtotal_without_service_fee",
      invoice.grandtotal_without_service_fee
    )

    allItems.map((item) => {
      formData.append(`names[]`, item.name)
      formData.append(`quantities[]`, item.qtyInput)
      formData.append(`units[]`, item.unit)
      formData.append(`prices[]`, item.price)
      formData.append(`supplies_expense_item_ids[]`, item.id)
      formData.append("item_remarks[]", item.remarks)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSEPurchaseInvoice = async (invoice, allItems) => {
  try {
    console.log(allItems)
    const formData = new FormData()
    invoice.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    invoice.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_expense_id", invoice.supplies_expense_id)
    formData.append("supplies_receive_id", invoice.id)
    formData.append("supplier_id", invoice.supplier_id)
    formData.append("vendor_id", invoice.vendor_id)
    formData.append("branch_id", invoice.branch_id)
    formData.append("purchase_date", invoice.purchase_date)
    formData.append("supplies_receive_date", invoice.received_date)
    formData.append("due_date", invoice.due_date)
    formData.append("forwarder_id", invoice.forwarder_id)
    formData.append("waybill_no", invoice.waybill_no)
    formData.append("invoice_no", invoice.invoice_no)
    formData.append("dr_no", invoice.dr_no)
    formData.append("type", invoice.type)
    // formData.append('expense_type_id', invoice.type);
    formData.append("service_fee", invoice.service_fee)
    formData.append("discount", invoice.discount)
    formData.append("remarks", invoice.remarks ? invoice.remarks : "")
    formData.append("subtotal", invoice.subtotal)
    formData.append("grand_total", invoice.grand_total)

    formData.append("withholding_percentage", invoice.withholding_percentage)
    formData.append("vat_type", invoice.vat_type)
    formData.append("discounted_subtotal", invoice.discounted_subtotal)
    formData.append("vat", invoice.vat)
    formData.append("vatable_sales", invoice.vatable_sales)
    formData.append("withholding_tax", invoice.withholding_tax)
    formData.append(
      "grandtotal_without_service_fee",
      invoice.grandtotal_without_service_fee
    )

    allItems.map((item) => {
      formData.append(`names[]`, item.name)
      formData.append(`quantities[]`, item.qtyInput)
      formData.append(`units[]`, item.unit)
      formData.append(`prices[]`, item.price)
      formData.append(
        `supplies_expense_item_ids[]`,
        item.supplies_expense_item_id
      )
      formData.append("item_remarks[]", item.remarks)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getSEPaymentHistory = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receives/get_all_invoice_payments",
      {
        requester: getUser(),
        token: getToken(),
        supplies_receive_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
